import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

const DashboardActionsMenu: React.FC = () => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    if (open) {
      document.addEventListener('mousedown', onOutside);
    }
    return () => document.removeEventListener('mousedown', onOutside);
  }, [open]);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="btn-secondary text-sm py-2 px-3 inline-flex items-center justify-center rounded-md"
        aria-expanded={open}
        aria-haspopup="menu"
      >
        More
      </button>
      {open ? (
        <>
          <div className="fixed inset-0 z-10" aria-hidden onClick={() => setOpen(false)} />
          <div
            role="menu"
            className="absolute right-0 mt-2 w-48 bg-surface rounded-md shadow-modern border border-border z-20 overflow-hidden"
          >
            <Link
              to="/leads?import=choose"
              role="menuitem"
              className="block px-4 py-2.5 text-sm text-fg hover:bg-app"
              onClick={() => setOpen(false)}
            >
              Import CSV
            </Link>
            <Link
              to="/settings/website"
              role="menuitem"
              className="block px-4 py-2.5 text-sm text-fg hover:bg-app"
              onClick={() => setOpen(false)}
            >
              Connect website
            </Link>
            <Link
              to="/leads?tab=pipeline"
              role="menuitem"
              className="block px-4 py-2.5 text-sm text-fg hover:bg-app border-t border-border"
              onClick={() => setOpen(false)}
            >
              View pipeline
            </Link>
          </div>
        </>
      ) : null}
    </div>
  );
};

export default DashboardActionsMenu;
